import {
  Inquiry,
  InquiryFetchArgs,
  getInquiries,
} from '../../assets/ts/data/inquiry/inquiry'
import useServerData from '../use-server-data'

function useInquiry(fetchArgs, waitOnParentDependency = false) {
  const {
    data: inquiry,
    error: inquiryError,
    fetchData: fetchInquiry,
    isLoading: inquiryIsLoading,
  } = useServerData<Inquiry, InquiryFetchArgs>(
    getInquiries,
     fetchArgs,
     waitOnParentDependency
    )

  return {
    fetchInquiry,
    inquiry,
    inquiryError,
    inquiryIsLoading,
    waitOnParentDependency
  }
}

export default useInquiry
